import { StateSliceDefaults, StateSliceName } from '@oneapp/main/core/store.models';

export enum FileSystemEntityType {
    FOLDER = 'Folder',
    MP4_VIDEO = 'MP4 Video',
    XCHANGE = 'Xchange'
}

export interface FileSystemEntity {
    type: FileSystemEntityType | string;
    name: string;
    date: string;
    size?: string;
    uri: string;
    children?: FileSystemEntity[];
}

export enum FileExplorerTableColumn {
    ENTITY_INFO = 'entityInfo',
    LAST_MODIFIED = 'lastModified',
    FILE_SIZE = 'fileSize',
    FILE_TYPE = 'fileType',
    CALL_TO_ACTION = 'cta'
}

export enum FileSystemEntityInfo {
    NAME = 'name',
    TYPE = 'type',
    IS_FOLDER = 'isFolder',
    ICON = 'icon',
    URL = 'url'
}

export enum FileSystemEntitySizeInfo {
    VALUE = 'value',
    READABLE = 'readable'
}

export interface BreadcrumbItem {
    name: string;
    uri: string;
}

export interface FileSystemEntityRow {
    /** Precomputed lowercase haystack for search; set when rows are built. */
    searchText?: string;
    [FileExplorerTableColumn.ENTITY_INFO]: {
        [FileSystemEntityInfo.NAME]: string;
        [FileSystemEntityInfo.TYPE]: string;
        [FileSystemEntityInfo.IS_FOLDER]: boolean;
        [FileSystemEntityInfo.ICON]: string;
        [FileSystemEntityInfo.URL]: string;
    };
    [FileExplorerTableColumn.LAST_MODIFIED]: string;
    [FileExplorerTableColumn.FILE_SIZE]: {
        [FileSystemEntitySizeInfo.VALUE]: number;
        [FileSystemEntitySizeInfo.READABLE]: string;
    };
    [FileExplorerTableColumn.FILE_TYPE]: string;
    [FileExplorerTableColumn.CALL_TO_ACTION]: string;
}

export enum FileExplorerSearchFormControlName {
    STRING_FILTER = 'stringFilter'
}

export interface FileExplorerFilterValues {
    [FileExplorerSearchFormControlName.STRING_FILTER]?: string;
}

export const DEFAULT_NUMBER_ENTRIES = 10;

export interface FileExplorerStateModel {
    navigationHistory: FileSystemEntity[] | undefined;
    formValues: FileExplorerFilterValues | undefined;
}

export const fileExplorerStateDefaults: StateSliceDefaults<FileExplorerStateModel> = Object.freeze({
    sliceName: StateSliceName.FILE_EXPLORER,
    defaults: {
        navigationHistory: undefined,
        formValues: {
            [FileExplorerSearchFormControlName.STRING_FILTER]: ''
        }
    }
});
